<template>
  <closeable-filter-badge-container
    class="filter-menu-element px-3 hover:bg-primary-light hover:text-primary-focus"
    @remove="onRemove"
  >
    <list-filter-value :labels="marketLabels"
                       :options="marketOptions"
                       :hide-labels="markets !== null && markets.length > 1"
                       label-full="All markets"
                       label-empty="No markets selected"
                       :class="{ 'gap-2': markets !== null && markets.length }"
    >
      <template>
        <span v-if="markets !== null && markets.length > 1">Markets:</span>
        <vs-icon icon="storefront" class="mr-1"/>
      </template>
    </list-filter-value>
  </closeable-filter-badge-container>
</template>

<script>
import CloseableFilterBadgeContainer from './CloseableFilterBadgeContainer.vue'
import ListFilterValue from '@/components/analytics/filter/ListFilterValue'
import { FILTER_ITEMS } from '@/utils/filter.constants'

export default {
  name: 'MarketsFilterBadge',

  props: {
    markets: {
      validator: value => value === null || Array.isArray(value),
      default: null
    },
    marketOptions: {
      type: Array,
      required: true
    }
  },

  components: {
    CloseableFilterBadgeContainer,
    ListFilterValue
  },

  computed: {
    marketLabels() {
      return this.markets === null ?
        this.marketOptions.map(({ name }) => name) :
        this.selectedMarkets.map(({ name }) => name)
    },

    selectedMarkets() {
      if (this.markets === null) return []

      return this.marketOptions.filter(
        ({ id }) => this.markets.includes(id)
      )
    }
  },

  methods: {
    onRemove() {
      this.$emit('remove', { [FILTER_ITEMS.MARKETS]: null })
    }
  }
}
</script>
